<template>
  <b-card no-body>
    <b-card-body class="py-2 px-3" v-if="profile">
      <b-img
        blank
        :height="100"
        :width="100"
        class="d-inline-block"
        style="vertical-align: top;"
        blank-color="#cccccc"
        rounded="circle"
        alt="Customer profile"/>

      <div class="d-inline-block ml-3 items">
        <collection-summary
          :profile="profile"
          :items="items"
          :summary_data="summary_data"/>
      </div>

     
    </b-card-body>
    <loading-spinner v-else/>
  </b-card>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../../utils';
  import LoadingSpinner from '../LoadingSpinner';
  import SummaryBlock from './SummaryBlock';
  import CollectionSummary from './CollectionSummary';
  import moment from "moment";

  const dateFormat = dateString =>
    moment(dateString).format("MMM DD, YYYY");

  const dateToAge = dateString =>
    moment().diff(dateString, "years");

  const phoneFormat = number => {
    number = String(number);
    if (number.startsWith('0') || number.startsWith('+'))
      return number;
    return `+${number}`;
  };


  export default {
    name: 'CustomerSummaryView',

    components: {
      LoadingSpinner,
      SummaryBlock,
      CollectionSummary
    },

    props: {
      id: {
        type: String,
        required: true
      },
      database: {
        type: String,
        required: true
      },
      collection: {
        type: String,
        required: true
      },
    },

    data() {
      return {
        profile: null,
        summary_data: null,
        items: null,
        leftBlockItems: [
          {key: "customer_name", icon: "fa-user"},
          {key: "registration_date", icon: "fa-calendar", prefix: "Registered on ", format: dateFormat},
          {key: "gender", icon: "fa-venus-mars"},
          {key: "dob", icon: "fa-anchor", format: dateFormat, prefix: "Birthday "},
          {key: "dob", icon: "fa-at", format: dateToAge, suffix: " years"},
        ],
        rightBlockItems: [
          {key: "mobile", icon: "fa-phone", format: phoneFormat},
          {key: "location", icon: "fa-map-marker"},
          {key: "county", icon: "fa-map-marker"},
          {key: "country", icon: "fa-flag"},
          {key: "branch", icon: "fa-university"}
        ]
      };
    },

    created() {
      axios.get(fullURL(`/360-view/${this.collection}/${this.id}`))
        .then(({data}) => {
          this.profile = data;
          const reusable_pick = (keys, obj) => keys.reduce((acc, key) => {
                acc[key] = obj[key];
                return acc;
            }, {});
            
          if(this.collection === 'sales_records'){

            this.summary_data = reusable_pick( ["customerName", "amountCollected","amountOutstanding","customerPhoneNumber"],this.profile[0])
            this.items = [ "fa-user", "fa-money", "fa-money", "fa-phone"]


          }
          else if(this.collection === 'users'){
            this.summary_data = reusable_pick( ["name","email","dateOfBirth","phoneNumber","active"],this.profile[0])
            this.items = ["fa-user", "fa-envelope",  "fa-birthday-cake", "fa-phone", "fa-anchor"]

          }
          else if(this.collection === 'customers'){
            this.summary_data = reusable_pick( ["customerName","customerPhoneNumber"],this.profile[0])
            this.items = [ "fa-user", "fa-phone"]

          }
        })
        .catch(console.log);
    },
  };
</script>

<style scoped>
  .items {
    min-width: 20%;
    vertical-align: top;
  }
</style>
